module.exports = __webpack_public_path__ + "media/video-banner-home.5f025ae5.mp4";